module.exports = __webpack_public_path__ + "static/img/h-i-10.f024cc4f.png";